import StringUtils from "../../../../util/StringUtils";

class SimCardTrafficUtils {
    public static getStatusText(status: string): string {
        switch (StringUtils.nonull(status).toUpperCase()) {
            case 'ACTIVATION':
                return '已激活';
            case 'DEACTIVATION':
                return '停卡';
            case 'RETIRED':
                return '已销卡';
            case 'INVENTORY':
                return '沉默期';
            case 'TESTING':
                return '测试期';
            default:
                return status || '-';
        }
    };
}

export default SimCardTrafficUtils;
